// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__PJM6B","spin":"styles_spin__DrcxJ"};